module.exports = __webpack_public_path__ + "assets/img/globe-icon.71f87c5a.svg";